var render = function (_h,_vm) {var _c=_vm._c;return _c('path',{attrs:{"d":"M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.011,8.011,0,0,1,12,20ZM15.88,8.29,10,14.17,8.12,12.29A1,1,0,0,0,6.71,13.7L9.3,16.29a1,1,0,0,0,1.41,0L17.3,9.7a1,1,0,0,0,0-1.41,1.008,1.008,0,0,0-1.42,0Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }